import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
export const fetchTrainingdata = createAsyncThunk("fetch-training", async (reqbody) => {
    console.log("reqbody==>", reqbody);
    let req_body = {};
    req_body = reqbody;
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "trainingapi/autocompletetrainings", requestOptions);
    const respdata = await response.json();
    console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});
////////////////////////////////////////

export const trainingData = createAsyncThunk("add-edit-lessons", async (reqbody) => {
    console.log("reqbody==>", reqbody);
    let req_body = {};
    req_body = reqbody;
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "trainingapi/fetch_training_data", requestOptions);
    const respdata = await response.json();
    console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});

////////////////////////////////// fetchlesson //////////////////////////////////
export const fetchlesson = createAsyncThunk("training/lesson", async (reqbody) => {
    console.log("reqbody 666", reqbody)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "trainingapi/lessonlistbytraining", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});

////////////////////////////////// fetchlesson //////////////////////////////////
export const fetchCompletedTrainingsLessons = createAsyncThunk("training/completedlessontraining", async (reqbody) => {
    console.log("reqbody 666", reqbody)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "api2/completelessonspertraining", requestOptions);
    const res = await response.json();

    return res;
});

////////////////////////////////// fetchlesson //////////////////////////////////
export const getLessons = createAsyncThunk("assigntrainingform/lesson", async (reqbody) => {
    console.log("reqbody 666", reqbody)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "trainingapi/lessonlistbytraining", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});


////////////////////////////////// Delete Multiple Lession form Table //////////////////////////////////
export const deletemultipleLession = createAsyncThunk("list-lessons", async (reqbody) => {
    console.log("reqbody 666", reqbody)
    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "trainingapi/gettrainingcenterdata", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});
////////////////////////////////// Delete Multiple Edit form Table //////////////////////////////////

export const editmultyplelesson = createAsyncThunk("lesson-list-edit", async (reqbody) => {

    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "trainingapi/lessonsaddeditmultiple", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});



export const trainingcenterdata = createAsyncThunk("traningcenter", async (reqbody) => {
    console.log("reqbody==>", reqbody);
    let req_body = {};
    req_body = reqbody;
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "trainingapi/gettrainingcenterdata", requestOptions);
    const respdata = await response.json();
    console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});

export const markDoneLesson = createAsyncThunk('training/lesson/markasdone', async (reqbody) => {
    console.log('reqbody======>', reqbody)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqbody)
    };

    const response = await fetch(process.env.REACT_APP_API_URL + "api/donetraining", requestOptions);
    const res = await response.json();
    return res;
})




////////////////////////////////// Delete Multiple Item form Table //////////////////////////////////
export const deletemultipleTraining = createAsyncThunk("traning-list-delete", async (reqbody) => {

    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "trainingapi/deletemultiple", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});



////////////////////////////////// Delete Multiple Item form Table //////////////////////////////////
export const editmultyple = createAsyncThunk("traning-list-edit", async (reqbody) => {

    let req_body = {};
    req_body = reqbody;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "trainingapi/addedittraining", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});


////////////////////////////////// Edit Multiple Item form Table //////////////////////////////////
export const traningaddeditmultiple = createAsyncThunk("edit-multi", async (reqbody) => {

    let req_body = {};
    req_body = reqbody;
    console.log("reqbody 666", reqbody)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "trainingapi/trainingAddEditMultiple", requestOptions);
    const respdatafordelete = await response.json();

    return respdatafordelete;
});

/////////////////////////////////////training status////////////////////////////////////////
export const training_status = createAsyncThunk("training-status", async (reqbody) => {
    let req_body = {};
    req_body = { ...reqbody };
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api/trainingdetailsinformation", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});

/////////////////////////////////////manager_training status list////////////////////////////////////////
export const manager_training_status = createAsyncThunk("manager-training-status", async (reqbody) => {
    let req_body = {};
    req_body = { ...reqbody };
    console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "api6/managertraininglist", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});



const trainingManagment = createSlice({
    name: 'trainingManagment',
    initialState: {
        submitting: false,
        trainingdata: [],
        trainingcenterdatas: {},
        submitted: false,
        message: null,
        success: false,
        loading: false,
        successmsg: "",
        lessons: [],
        prequestLessons: [],
        prequestTraining: [],
        selectedTrainingName: '',
        forTrainingStatus: {},
        trainingPercent: null,
        next_lesson_id: undefined,
        training_id: undefined,
        next_training_ID: undefined,
        trainingdatacount: null,
        donetrainingdatacount: null,
        manager_training_data: [],
        completedTrainingLessons: [],
        done_training_data: {},
        next_lesson_flag: false,
        tpm_entry_access: {},
        topoff_entry_access:null
        // addUserData: []
    },
    reducers: {
        setSuccessAfterSubmit(state, action) {
            state.success = false;
        },
        resetnextlessonflag(state, action) {
            state.next_lesson_flag = false;
        }
    },

    extraReducers: {
        //////////////////////////////////// Lesson Mark as Done //////////////////////////////////
        [markDoneLesson.pending]: (state, action) => {

        },
        [markDoneLesson.fulfilled]: (state, action) => {
            state.done_training_data = { ...action.payload.results };
            if (action.payload.results.next_lesson_id == null) {
                state.next_lesson_flag = true;
                state.next_training_ID = action.payload.results.next_training_id
            }
        },
        [markDoneLesson.rejected]: (state, action) => {

        },

        //////////////////////// Fetch Lessons for Add edit Prequest Lesson ////////////////
        [fetchlesson.pending]: (state, action) => {

        },
        [fetchlesson.fulfilled]: (state, action) => {
            if (action.payload.status == 'success') {
                state.prequestLessons = [];
                action.payload.results.res.forEach((cur) => {
                    state.prequestLessons.push({ val: cur._id, name: cur.lessons_name });
                })
            }
        },
        [fetchlesson.rejected]: (state, action) => {

        },

        /////////////////////////////////////////////////// Get Lessons On clicking training in training center ////////////////////////////////
        [getLessons.pending]: (state, action) => {
            state.loading = true;
        },
        [getLessons.fulfilled]: (state, action) => {
            state.loading = false;
            if (action.payload.status === 'success') {
                state.lessons = action.payload.results.res;
            } else {
                state.lessons = []
            }
        },
        [getLessons.rejected]: (state, action) => {
            state.loading = false;
            state.lessons = []
        },
        //////////////////////////////////// Fetching City List ///////////////////////////////
        [fetchTrainingdata.pending]: (state, action) => {
            console.log("action p", action)
            state.trainingdata = ['Loading...'];
        },
        // [fetchTrainingdata.fulfilled]: (state, action) => {
        //     console.log("action f", action)
        //     if (action.payload.status === 'success') {
        //         state.trainingdata = [...action.payload.result];
        //         state.message = action.payload.status;
        //         state.submitted = true;
        //     }
        // },
        [fetchTrainingdata.rejected]: (state, action) => {
            console.log("action r", action)
            state.trainingdata = ['Something Went Worng !!'];
        },
        /////////////////////////////////////////////
        [fetchTrainingdata.fulfilled]: (state, action) => {
            if (action.payload.status == 'success') {
                state.prequestTraining = [];
                action.payload.results.res.forEach((cur) => {
                    state.prequestTraining.push({ val: cur._id, name: cur.name })
                })
            }
        },
        //training center data

        [trainingcenterdata.pending]: (state, action) => {
            console.log("action p", action)
        },
        [trainingcenterdata.fulfilled]: (state, action) => {
            console.log("action f", action)
            if (action.payload.status === 'success') {
                state.trainingcenterdatas = { ...action.payload.result };
                state.message = action.payload.status;
                state.submitted = true;
            }
        },
        [trainingcenterdata.rejected]: (state, action) => {
            console.log("action r", action)
        },

        //////////////////////////// Delete Multiple Lession ///////////////////////////////
        [deletemultipleLession.pending]: (state, action) => {
            state.loading = true;
        },
        [deletemultipleLession.fulfilled]: (state, action) => {
            console.log("action 666", action)
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Delete Successfully'
                state.success = true;
            }
        },
        [deletemultipleLession.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },

        //////////////////////////// Edit Multiple Lession ///////////////////////////////
        [editmultyplelesson.pending]: (state, action) => {
            state.loading = true;
        },
        [editmultyplelesson.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully'
                state.success = true;
            }
        },
        [editmultyplelesson.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },



        //////////////////////////// Delete Multiple Item ///////////////////////////////
        [deletemultipleTraining.pending]: (state, action) => {
            state.loading = true;
        },
        [deletemultipleTraining.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Deleted Successfully';
                state.success = true;
            }
        },

        [deletemultipleTraining.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },
        //////////////////////////// Edit Multiple Item ///////////////////////////////

        [traningaddeditmultiple.pending]: (state, action) => {
            state.loading = true;
        },
        [traningaddeditmultiple.fulfilled]: (state, action) => {
            if (action.payload.status === "success") {
                state.loading = false;
                state.successmsg = 'Updated Successfully'
                state.success = true;
            }
        },
        [traningaddeditmultiple.rejected]: (state, action) => {
            state.loading = false;
            state.successmsg = 'Something went wrong';
        },
        ////////////////////////////////////////training status extra reducer//////////////////////////

        [training_status.rejected]: (state, action) => {
            state.loading = false;
        },
        [training_status.pending]: (state, action) => {
            state.loading = true;
        },
        [training_status.fulfilled]: (state, action) => {
            if (action.payload.status === 'success') {
                // state.forTrainingStatus = [...state.forTrainingStatus,...action.payload.result];
                state.forTrainingStatus = { ...action.payload.result };
                state.trainingPercent = action.payload.trainingpercentge
                state.trainingdatacount = action.payload.trainingdatacount
                state.donetrainingdatacount = action.payload.donetrainingdatacount
                state.loading = false;
                state.training_id = action.payload.training_id
                state.next_lesson_id = action.payload.next_lesson_id;
                state.topoff_entry_access = action.payload.result.frycook_tpm_topoff_data?action.payload.result.frycook_tpm_topoff_data[0]?.topoff_entry_access:null;
                state.tpm_entry_access = action.payload.result.frycook_tpm_topoff_data?action.payload.result.frycook_tpm_topoff_data[0]?.tpm_entry_access:null;
            }
        },

        //manager_training status list data

        [manager_training_status.pending]: (state, action) => {
        },
        [manager_training_status.fulfilled]: (state, action) => {
            state.manager_training_data = { ...action.payload.result };
        },
        [manager_training_status.rejected]: (state, action) => {
        },


        //fetch completed training lessons

        [fetchCompletedTrainingsLessons.pending]: (state, action) => {
        },
        [fetchCompletedTrainingsLessons.fulfilled]: (state, action) => {
            if (action.payload.status == 'success') {
                state.completedTrainingLessons = action.payload.results.res;
                state.totalTrainingLessons = action.payload.results.response
            }
        },
        [fetchCompletedTrainingsLessons.rejected]: (state, action) => {
        },

    },



})

export const { setSuccessAfterSubmit, resetnextlessonflag } = trainingManagment.actions;
export const { lessonDeletesuccess } = trainingManagment.actions;


export default trainingManagment.reducer;